import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v4';

const resetPasswordSearchSchema = z
  .object({
    mode: z.string().optional(),
    oobCode: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute('/_public/reset-password')({
  component: lazyRouteComponent(() => import('&/features/reset-password/pages/reset-password-page')),
  staticData: { titleKey: 'resetPassword' },
  validateSearch: (search) => resetPasswordSearchSchema.parse(search),
});
